import { inject, Injectable } from '@angular/core';
import { EventLoggerService } from './event-logger-service';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Injectable({
	providedIn: 'root',
})
export default class GoogleTagManagerEventLoggerService implements EventLoggerService {
	private readonly gtmService = inject(GoogleTagManagerService);

	public logEvent(message: string, payload?: Record<any, any>): void {
		try {
			this.gtmService.pushTag({
				...(payload ?? {}),
				message,
			});
		} catch {
			// GTM may be blocked by content blockers in local/dev environments.
		}
	}
}
